import { render, staticRenderFns } from "./downApp.vue?vue&type=template&id=4e601e4e&scoped=true"
import script from "./downApp.vue?vue&type=script&lang=js"
export * from "./downApp.vue?vue&type=script&lang=js"
import style0 from "./downApp.vue?vue&type=style&index=0&id=4e601e4e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e601e4e",
  null
  
)

export default component.exports